export default __webpack_public_path__ + "static/media/notification.9b8cf68a.svg";